<template>
  <div class="s-warp" :id="id">
    <input
      type="text"
      class="clearInput"
      :class="tip && required ? 'inputWarn': ''"
      v-model="label"
      @blur="blurInput"
      @focus="focusInput"
      @input="changeWord"
      :placeholder="setPlaceholder"
    />
    <div class="s-show" v-if="isShow">
      <el-scrollbar>
        <div >
          <div v-if="status === 0" class="NoData">
            <img src="../../../assets/img/loading.gif" class="s-loading" />
          </div>
          <div v-if="status === -1" class="NoData">
            <div class="textC" style="line-height: 2">error</div>
          </div>
          <template  v-if="status === 1" >
            <div v-show="!selectData.length" class="NoData">No Data</div>
            <ul v-show="selectData.length" class="s-ulBox indexBox">
              <slot></slot>
            </ul>
          </template>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import Emitter from "@/utils/emitter";
export default {
  name: "BySelect",
  componentName: "BySelect",

  mixins: [Emitter],

  props: {
    selectData: { type: Array },
    setPlaceholder: { type: String, default: "" },
    valueObj: { type: Object },
    required: { type: Boolean },
    status: { type: Number , default: 1 }, //状态码 如果调取接口可以传值 -1 失败 0 加载中 1 成功
    id: { type: String , default:  'id'+Date.now().toString( Math.floor(Math.random() * (34)) + 2) },
    //需要一个唯一值 否则可能出现同一页面相互影响  
  },

  model: {
    prop: "valueObj",
    event: "callEvent",
  },

  data() {
    return {
      label: "",
      curMsgObj: {},
      isShow: false,
      curIndex: 0,
      tip: false,       
      
    };
  },

  created() {
    this.$on("curOptVal", this.curOptVal);
  },
  watch: {
    valueObj: {
      deep: true,
      handler: function (newV, oldV) {
        this.label = this.valueObj.label
        this.curMsgObj = this.valueObj
      },
    },
  },

  mounted() {
    document.addEventListener("click", (e) => {
      if (this.isShow) {
        var sp = document.getElementById(this.id);
        if (sp && !sp.contains(e.target)) {
          this.isShow = false;
        }
      }
    });
  },
  methods: {
    // 如果想要
    blurInput() {
      this.$emit("blur", this.label);
      // 判断加上 undefined的情况
      if (this.label !== this.curMsgObj.label || !this.label) {
        this.label = "";
        this.tip = true
        // 响应v-model 事件
        this.$emit("callEvent", {});
      }
    },
    focusInput() {
      this.$emit("focus", this.label);
      this.isShow = true
      this.tip = false
    },
    curOptVal(val) {
      this.tip = false
      this.curMsgObj = val;
      this.label = val.label;
      // 响应v-model 事件
      this.$emit("callEvent", this.curMsgObj);
      // 提供change事件
      this.$emit("change", this.curMsgObj);
      this.isShow = false;
    },
    changeWord() {
      // 输入事件  
      this.$emit("filterOpt", this.label);
    },
    // 
    tipsShow() {
      if(this.label){
        this.tip = false
      }else{
        this.tip = true
      }
    },
   
  },
};
</script>
<style scoped>
.clearInput {
  background: none;
  outline: none;
  border: 1px solid #dcdfe6;
  height: 28px;
  padding: 0 5px !important;
  border-radius: 4px;
  font-size: 12px;
  width:170px;
}
.clearInput:focus {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.s-label {
  height: 30px;
  line-height: 30px;
  font-size: 13px;
}
.s-loading {
  width: 20px;
  margin: 10px auto;
}
.s-warp {
  display: inline-block;
  vertical-align: top;
  position: relative;
  font-size: 13px;
}
.s-header {
  font-weight: 700;
  padding-left: 6px;
  background: #f0f0f0;
  line-height: 30px;
  font-size: 13px;
}
.s-ulBox {
  max-height: 300px;
  width: 180px;
  padding: 10px 0;
}

.s-show {
  position: absolute;
  overflow-x: hidden;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  left: 0px;
  z-index: 66;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.is-active {
  background: #f5f7fa;
}
.NoData {
  color: #555;
  width: 170px;
  text-align: center;
  line-height: 30px;
  font-size: 12px;
  padding: 5px;
}

.indexSelect .clearInput {
      width: 220px !important;
      background: white !important;
    }
.indexSelect .s-ulBox {
  width: 230px !important;
}
.indexSelect .NoData {
  width: 220px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Reception/public/bySelect.vue